// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"858646f7","931":"7da874c5"}[chunkId] + ".chunk.js";
};